import { previewSidebar } from '@/translations/en/editor/previewSidebar'
import { sizing } from '@/translations/en/editor/sizing'
import { tabs } from '@/translations/en/editor/tabs'

export const editor = {
  title: 'Editor',
  models: 'Models',
  position: 'Position',
  rotation: 'Rotation',
  scale: 'Scale',
  size: 'Size',
  name: 'Name',
  addModels: 'Add models',
  noModelsLoaded: 'No models loaded',
  noModelsLoadedDescription: 'Add them in the "Models" tab',
  goBackToStep: 'Go back to confugration editing',
  downComplete: 'Downloaded files successfully',
  loadComplete: 'Model loaded successfully',
  addModel: 'Load model into editor',
  fileAddedPara1: 'Your file has been added and is ready',
  fileAddedPara2: 'Would you like to load it into the view?',
  fileNotFound:
    'There was a problem finding the file. Try again or select one from the list.',
  fileCannotBeLoaded: 'There was a problem loading the file',
  resetCamera: 'Reset camera',
  toggleRotation: 'Toggle camera rotation',
  toggleFullscreen: 'Fullscreen mode',
  changeSceneWidth: 'Change scene width',
  sceneWidthTitle: 'Scene width',
  applySceneWidth: 'Apply width',
  resetSceneWidth: 'Reset to default width',
  floorGrid: 'Floor grid',
  focusElement: 'Focus on model',
  modifiedNode: 'Model has unsaved changes',
  hideModel: 'Hide model',
  toggleTransform: 'Toggle transform controls (Shift + E)',
  deleteModel: 'Delete model and its changes',
  deleteModelTitle: 'Are you sure?',
  deleteModelWarning:
    'Deleting this will also remove fields from the changes list. Are you sure you want to delete this model?',
  press: 'Press',
  toSetNormal: 'to move in space',
  toSetRotate: 'to edit rotation',
  toSetScale: 'to edit scale',
  modelsDimensions: 'Model dimensions',
  length: 'Length',
  height: 'Height',
  width: 'Width',
  code: 'Code',
  detectedErrors: 'Detected {count} errors',
  nextError: 'Next error',
  prevError: 'Previous error',
  revalidate: 'Check for errors',
  uploadModel: 'Upload model file',
  showModel: 'Show model in the view',
  loading: 'Loading editor...',
  tabs: tabs,
  sizing: sizing,
  previewSidebar: previewSidebar,
  groups: {
    node: 'Node groups',
    select: 'Choose group',
    savedCorrectly: 'Groups saved successfully',
    added: 'Group added successfully',
    deleteConfirm: 'Are you sure you want to delete this group?',
    deletePara: 'This action cannot be undone',
    modelAlsoBelongs: 'This model belongs to other groups as well',
    modelAlsoNotBelongs: 'This model does not belong to any other group',
    assignedToOtherGroups: 'This model is assigned to other groups',
    otherGroups: 'Other groups',
    noneSelected: 'No group chosen',
    save: 'Save groups',
  },
  errors: {
    notFoundSavingModel:
      'Model not found in the list. Please use "Save as new".',
    dimensionMustBePositive: 'Dimensions must be positive values',
    notFoundLoadingModel:
      'Model not found. Please check the code and try again.',
  },
  success: {
    saved: 'Model saved successfully',
    changedVisibility: 'Model visibility changed successfully',
    changesReverted: 'Model changes reverted successfully',
  },
  validation: {
    fixErrors: 'Please fix the errors before applying changes',
    codeRequired: 'Code is required',
    lengthPositive: 'Length must be a positive value',
    heightPositive: 'Height must be a positive value',
    widthPositive: 'Width must be a positive value',
    nameRequired: 'Name is required',
  },
  chooseBackground: 'Choose background',
  chooseBackgroundN: 'Choose background {n}',
  chooseScenery: 'Choose scenery',
  chooseSceneryN: 'Choose scenery {n}',
  withGrid: 'With grid',
  withoutGrid: 'Without grid',
  dragHover: 'Hover mouse over the value and drag to change it',
  dependencies: {
    noDependenciesGlobal: 'No dependencies available for this configuration',
    noDependenciesGlobalDescription: 'Add them on the dashboard',
    noDependencies: 'No dependencies for this node',
    title: 'Model dependencies',
    rules: 'Rules',
    models: 'Models',
    options: 'Options',
    groups: 'Groups',
    dependenciesFor: 'Dependencies for ',
    hasDependencies: 'This node has dependencies',
    noDependenciesIcon: 'This node has no dependencies',
    expandAll: 'Expand all',
    collapseAll: 'Collapse all',
  },
  properties: {
    elementVisible: 'Element is visible by default',
    elementNotVisible: 'Element is hidden by default',
  },
  lights: {
    title: 'Lights',
    label: 'Label',
    code: 'Code',
    type: 'Type',
    disabled: 'Disabled',
    enabled: 'Enabled',
    intensity: 'Intensity',
    color: 'Color',
    angle: 'Angle',
    x: 'X',
    y: 'Y',
    z: 'Z',
    global: 'Global',
    updated: 'Updated',
    copy: 'Copy',
    castsShadow: 'Casts shadow',
    edit: 'Edit',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    all: 'All',
    newLight: 'New light',
    deleteConfirmTitle: 'Delete light?',
    deleteConfirmDescription: 'This action cannot be undone.',
    deleteConfirmGlobal:
      'This light will be remove from all configurations. Are you sure?',
    addLight: 'Add light',
    chooseNewLightType: 'Choose the new light type',
    chooseLightScope: 'Choose light scope',
    lightType: {
      ambient: 'Ambient',
      directional: 'Directional',
    },
    scope: {
      global: 'Global',
      local: 'Local',
    },
    noLights: 'No lights added yet',
    assign: 'Assign',
    unlinkAssign: 'Unlink assign',
    assigned: 'Assigned',
    globalSaveWarning:
      'This light is global. Changes will affect all configurations that use it.',
    confirmGlobalSave: 'Save Anyway',
    cancelGlobalSave: 'Cancel',
    savedSuccess: 'Light saved successfully',
    updatedSuccess: 'Light updated successfully',
    assignedSuccess: 'Light assigned successfully',
    unassignedSuccess: 'Light unassigned successfully',
  },
}
